import { combineReducers } from 'redux';
import divisionReducer from './division/reducer';

const rightsReducer = combineReducers({
    division: divisionReducer,
});

export default rightsReducer;